import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
//import TopSubMenu from "./TopSubMenu";
import BottomMenu from "../layout/BottomMenu";

export default function Layout() {
  const role = sessionStorage.getItem("role"); 
  const [isOpen, setIsOpen] = useState(false);
  const [ setActiveMenu] = useState(null);

  return (
    <div className="flex flex-col h-screen">

      <Header toggleSidebar={() => setIsOpen(!isOpen)} />

      <div className="flex flex-1 overflow-hidden">

        <Sidebar
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setActiveMenu={setActiveMenu}
        />

        <div className="flex flex-col flex-1 overflow-hidden">

          {/* <TopSubMenu activeMenu={activeMenu} /> */}

          <main className="flex-1 overflow-y-auto p-4 bg-gray-100">
            <Outlet />
          </main>
          <BottomMenu  role={role}/>

        </div>

      </div>

    </div>
  );
}